import { Box, Divider, TextField } from '@mui/material';
import { Headings } from 'components/atoms/Typography';
import useTranslation from 'next-translate/useTranslation';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers';
import AddComment from './Comment';

interface IDriverCommentProps {
    onChange?: (value) => void;
}

const DriverComment = ({ onChange }: IDriverCommentProps) => {
    const { t } = useTranslation('common');
    const userCart = useSelector((state: RootState) => state.userCart).data;

    if (!userCart) return null;

    return (
        <Box mb={{ xs: 2, md: 0 }}>
            <Divider sx={{ mt: 2, mb: 4 }} />
            <Box>
                <Box mt={{ xs: 4, md: 3 }} width="100%">
                    <AddComment
                        onChange={val => onChange?.(val)}
                        title={t('addCommentDriver')}
                        placeholder={t('addCommentDriverPlaceholder')}
                        initialValue={userCart?.driverComment}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default DriverComment;
